export const PUBLIC_ROUTES = ['/', '/email', '/404', '/maintenance'];

export enum Partner {
  business = 'business',
  demo = 'demo',
  essence = 'essence',
}

export interface PartnerConfig {
  getOrders: boolean;
  getEligibilities: boolean;
  invalidStep: string;
  accountStep: string;
  publicRoutes?: string[];
  overrideLocale?: string;
  supportEmail?: string;
  // Routes to ensure new data is fetched
  fetchDataRoutes?: string[];
  // Check if the user is eligible
  checkEligibility?: boolean;
}

export const config: Record<Partner, PartnerConfig> = {
  demo: {
    getOrders: false,
    getEligibilities: false,
    invalidStep: '/',
    accountStep: '/',
    publicRoutes: PUBLIC_ROUTES,
  },
  essence: {
    getOrders: true,
    getEligibilities: false,
    invalidStep: '/invalid-email',
    accountStep: '/account',
    overrideLocale: 'en',
    supportEmail: 'partnersupport@ouraring.com',
    fetchDataRoutes: ['/account'],
    publicRoutes: PUBLIC_ROUTES,
    checkEligibility: true,
  },
  business: {
    getOrders: true,
    getEligibilities: true,
    invalidStep: '/invalid-email',
    accountStep: '/account',
    supportEmail: 'partnersupport@ouraring.com',
    fetchDataRoutes: ['/account'],
    publicRoutes: [...PUBLIC_ROUTES, '/redeem/*'],
  },
  //add more configs for each "tenant" or "partner"...
};
